/* ============================================================
 * bundle-quantity.js — v2 (anti-boucle)
 * ------------------------------------------------------------
 * Corrige le spam infini d'events `options:price` (et le bug
 * "tout devient CHF" qui en découle) causé par une boucle de
 * feedback entre LPO et ce script.
 *
 * Principes :
 *  1. UNE SEULE source de vérité : l'event LPO `options:price`.
 *     -> Le MutationObserver sur le prix a été SUPPRIMÉ (c'était
 *        le 2e chemin de boucle : il lisait le prix dans le DOM).
 *  2. VERROU par signature : tout event identique au précédent
 *     est ignoré -> la boucle LPO <-> script meurt en 1 cycle.
 *  3. Écritures IDEMPOTENTES : on ne réécrit un .tier-total que
 *     si son HTML a réellement changé -> zéro mutation inutile.
 *
 * Le Liquid (main-product.liquid) n'a PAS besoin d'être modifié :
 * #bundle-tiers et ses data-* survivent au changement d'option.
 * ============================================================ */

(function () {
  'use strict';

  // Marqueur de déploiement : doit apparaître 1x dans la console au chargement.
  try { console.info('[bundle-quantity] v2 loaded'); } catch (_) {}

  /* ================== CONFIG ================== */

  var SHOW_UNIT_PRICE = false;
  var INCLUDE_OPTIONS_IN_COMPARE = true;

  // Applique le prix de l'option (ex. "2 faces" = 1,50 CHF) aux totaux des paliers.
  var APPLY_OPTION_SURCHARGE = true;

  // Comment le prix de l'option se répercute sur chaque palier :
  //   'per_unit'  -> +prix x quantité  (ex. 12 balles 2 faces = +1,50 x 12 = +18,00)
  //   'per_order' -> +prix forfaitaire une seule fois par palier (ex. +1,50)
  // ⚠️ DOIT correspondre à la façon dont LPO facture l'option au panier.
  //    Vérifie en ajoutant un palier au panier et en regardant le montant ajouté.
  var OPTION_SURCHARGE_MODE = 'per_unit';

  var BUNDLE_CONTAINER_SELECTOR = '#bundle-tiers';
  var BASE_UNIT_EL_ID = 'base-unit-price';

  var EPS = 0.005; // 0.5 centime

  /* ================== ÉTAT GLOBAL ================== */

  // Prix de l'option sélectionnée (en CHF). Source unique : event LPO `options:price`.
  var optionPriceLpo = 0;

  // Signature du dernier event traité -> verrou anti-boucle.
  var __lastSig = null;

  // Anti-réentrance : on écrit dans le DOM des paliers.
  var __isUpdatingTiers = false;

  // Debounce (coalesce les rafales d'events dans une même frame).
  var __rafScheduled = false;

  /* ================== UTILS ================== */

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function moneyCH(n) {
    return 'CHF ' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
  }

  function getBaseUnit() {
    var el = document.getElementById(BASE_UNIT_EL_ID);
    if (!el) return 0;
    var cents = parseInt(el.getAttribute('data-base-unit-price-cents') || '0', 10);
    if (isNaN(cents)) cents = 0;
    return cents / 100;
  }

  function readTiers(container) {
    if (!container) return [];
    var raw = container.getAttribute('data-tiers') || '';
    var arr = [];
    try {
      var v = JSON.parse(raw);
      arr = Array.isArray(v) ? v : [];
    } catch (_) {
      arr = String(raw).split(/[,\|;\s]+/);
    }
    return arr
      .map(function (x) { return parseInt(x, 10); })
      .filter(function (n) { return n > 0; });
  }

  function readTierPrices(container) {
    try {
      var raw = container.getAttribute('data-tier-prices');
      if (!raw || raw === 'null') return {};
      var obj = JSON.parse(raw);
      if (typeof obj === 'string') {
        try { obj = JSON.parse(obj); } catch (_) { obj = {}; }
      }
      return obj && typeof obj === 'object' ? obj : {};
    } catch (_) {
      return {};
    }
  }

  function scheduleRecalc() {
    if (__rafScheduled) return;
    __rafScheduled = true;
    requestAnimationFrame(function () {
      __rafScheduled = false;
      if (__isUpdatingTiers) return;
      var container = qs(BUNDLE_CONTAINER_SELECTOR);
      if (container) updateTotals(container);
    });
  }

  /* ================== SYNC FORMULAIRES ================== */

  function syncAllFormsQty(container) {
    var sel = qs('input[name="bundle_tier"]:checked', container);
    if (!sel) return;
    var qtyValue = sel.value;

    qsa('form[action*="/cart/add"]').forEach(function (form) {
      var q = qs('input[name="quantity"]', form);
      if (!q) {
        q = document.createElement('input');
        q.type = 'hidden';
        q.name = 'quantity';
        form.appendChild(q);
      }
      q.value = qtyValue;

      var propQty = qs('input[name="properties[BundleQty]"]', form);
      if (!propQty) {
        propQty = document.createElement('input');
        propQty.type = 'hidden';
        propQty.name = 'properties[BundleQty]';
        form.appendChild(propQty);
      }
      propQty.value = qtyValue;
    });
  }

  /* ================== CALCUL DES TOTAUX (idempotent) ================== */

  function updateTotals(container) {
    if (!container) container = qs(BUNDLE_CONTAINER_SELECTOR);
    if (!container) return;

    var tiers = readTiers(container);
    if (!tiers.length) return;

    var base = getBaseUnit();
    var tierMap = readTierPrices(container);
    var optAmt = APPLY_OPTION_SURCHARGE ? optionPriceLpo : 0;

    __isUpdatingTiers = true;
    try {
      qsa('label[data-bundle-tier]', container).forEach(function (label) {
        var qty = parseInt(label.getAttribute('data-bundle-tier'), 10);
        if (!qty) return;

        var unitAtTier =
          tierMap[String(qty)] != null
            ? parseFloat(tierMap[String(qty)])
            : base;

        // Surcoût appliqué selon le mode : par unité (x qté) ou forfaitaire.
        var surcharge =
          OPTION_SURCHARGE_MODE === 'per_order' ? optAmt : optAmt * qty;

        var total = unitAtTier * qty + surcharge;

        var compareSurcharge = INCLUDE_OPTIONS_IN_COMPARE ? surcharge : 0;
        var compareTotal = base * qty + compareSurcharge;
        var strike = total < compareTotal - EPS;

        var totalSpan = qs('.tier-total', label);
        if (totalSpan) {
          var html =
            (strike ? '<s>' + moneyCH(compareTotal) + '</s> ' : '') +
            '<strong>' + moneyCH(total) + '</strong>';
          // Idempotent : on n'écrit QUE si ça change (n'alimente pas LPO).
          if (totalSpan.innerHTML !== html) totalSpan.innerHTML = html;
        }

        if (SHOW_UNIT_PRICE) {
          var unitSpan = qs('.tier-unit', label);
          if (unitSpan) {
            var us = moneyCH(unitAtTier) + '/u';
            if (unitSpan.textContent !== us) unitSpan.textContent = us;
          }
        }
      });
    } finally {
      __isUpdatingTiers = false;
    }
  }

  /* ================== RENDER DES PALIERS ================== */

  function renderBundle(container) {
    if (!container) return;
    if (container.getAttribute('data-bundle-rendered') === 'true') return;

    var root =
      container.closest(
        '[data-section-type="product"], .product, .product__info-container'
      ) || document;

    var form =
      qs('form[action*="/cart/add"]', root) || qs('product-form form', root);
    if (!form) return;

    var qtyInput = qs('input[name="quantity"]', form);
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }

    var propQty = qs('input[name="properties[BundleQty]"]', form);
    if (!propQty) {
      propQty = document.createElement('input');
      propQty.type = 'hidden';
      propQty.name = 'properties[BundleQty]';
      form.appendChild(propQty);
    }

    var base = getBaseUnit();
    var tiers = readTiers(container);
    var tierMap = readTierPrices(container);
    if (!tiers.length) return;

    var html =
      '<fieldset class="bundle-tier" aria-label="Choisir une quantité"><legend>Quantité / Total</legend>';

    tiers.forEach(function (q, i) {
      var qty = parseInt(q, 10);
      var unitAtTier =
        tierMap[String(qty)] != null
          ? parseFloat(tierMap[String(qty)])
          : base;

      var total = unitAtTier * qty;
      var compareTotal = base * qty;
      var strike = total < compareTotal - EPS;

      html +=
        '<label data-bundle-tier="' + qty + '">' +
          '<input type="radio" name="bundle_tier" value="' + qty + '" ' + (i === 0 ? 'checked' : '') + '>' +
          '<span>' + qty + ' ex.</span>' +
          '<span class="tier-right">';

      if (SHOW_UNIT_PRICE) {
        html += '<span class="tier-unit">' + moneyCH(unitAtTier) + '/u</span>';
      }

      html += '<span class="tier-total">';
      if (strike) html += '<s>' + moneyCH(compareTotal) + '</s> ';
      html += '<strong>' + moneyCH(total) + '</strong>';
      html += '</span></span></label>';
    });

    html += '</fieldset>';

    container.innerHTML = html;
    container.setAttribute('data-bundle-rendered', 'true');

    syncAllFormsQty(container);
    scheduleRecalc();

    container.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'bundle_tier') {
        // Le choix de palier ne change que la qté envoyée au panier,
        // pas les totaux affichés -> pas besoin de recalcul ici.
        syncAllFormsQty(container);
      }
    });

    qsa('form[action*="/cart/add"]').forEach(function (f) {
      f.addEventListener('submit', function () {
        syncAllFormsQty(container);
      });
      var atc = qs('[type="submit"], button[name="add"], .add-to-cart', f);
      if (atc) {
        atc.addEventListener('click', function () {
          syncAllFormsQty(container);
        });
      }
    });
  }

  /* ================== INTÉGRATION LPO (options:price) ================== */

  window.addEventListener('options:price', function (e) {
    var d = (e && e.detail) || {};

    var priceCents = Number(d.price);
    var optionsCents = Number(d.options);
    if (!isFinite(priceCents)) priceCents = 0;
    if (!isFinite(optionsCents)) optionsCents = 0;

    // --- VERROU ANTI-BOUCLE ---
    // LPO peut re-dispatcher après notre écriture DOM : si la valeur est
    // identique, on ne fait RIEN -> aucune mutation -> LPO n'a plus rien à
    // observer -> la boucle s'éteint immédiatement.
    var sig = priceCents + ':' + optionsCents;
    if (sig === __lastSig) return;
    __lastSig = sig;

    // Prix brut de l'option (LPO le donne en centimes). Le mode d'application
    // (par unité ou forfaitaire) est géré dans updateTotals via OPTION_SURCHARGE_MODE.
    optionPriceLpo = optionsCents > 0 ? optionsCents / 100 : 0;

    scheduleRecalc();
  });

  /* ================== INIT ================== */

  function initBundlesFromDom(root) {
    root = root || document;
    var container = qs(BUNDLE_CONTAINER_SELECTOR, root);
    if (container) renderBundle(container);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundlesFromDom(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    // Une section a été rechargée (éditeur de thème) : on réautorise le
    // prochain event LPO et on re-rend si besoin.
    __lastSig = null;
    initBundlesFromDom(e.target);
  });
})();